import { Link, useNavigate } from "react-router-dom";

import kidheroimg from "../../assets/img/kidheroimg.png";
import AboutCephasKids from "../../components/cephas-kids/AboutCephasKids";
import WhatWeOffer from "../../components/cephas-kids/what-we-offer";
import Swing from "react-reveal/Swing";
import Jump from "react-reveal/Jump";
import HowItWorks from "../../components/cephas-kids/how-it-works";
import WhatSetsUsApart from "../../components/cephas-kids/WhatSetsUsApart";
import Testimonials from "../../components/cephas-kids/Testimonials";
import FAQ from "../../components/cephas-kids/Faq";
import NewsletterSubscription from "../../components/cephas-kids/NewsletterSubscription";
import Footer from "../../components/footer/footer.component";

// import HowItWorks from "../../components/cephas-kids/how-it-works";
// import Shake from "react-reveal/Shake";
// import Nav from "../../components/nav/nav.component";

const CephasKids = () => {
  return (
    <div className="min-h-screen overflow-x-hidden">
      {/* <Nav variant="dark" /> Explicitly set to dark variant */}
      {/* Hero Section */}
      <div
        className="relative min-h-screen flex items-center"
        style={{
          background: `linear-gradient(135deg, 
            rgba(17, 50, 150, 0.5) 0%, /* Lighter blue at top-left edge */
            rgba(17, 50, 150, 1) 20%, /* Main blue */
            rgba(255, 75, 1, 0.70) 80%, /* Orange with 70% opacity */
            rgba(255, 75, 1, 0.79) 100% /* Orange with 79% opacity */
          )`,
        }}
      >
        <div className="container mx-auto px-4 md:px-6 lg:px-24 lg:pt-20 md:pt-32 pt-32 ">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <Swing>
                <h1 className=" animate__animated animate__shakeX text-6xl md:text-5xl lg:text-[70px] tracking-wider font-black lg:font-black font-DM_SANS mb-6 ">
                  Join Our Kids' Tech Summer School
                </h1>
              </Swing>

              {/* <p className="text-xl md:text-2xl mb-8 opacity-90">
                Let your kids learn to create, code, and think creatively
              </p> */}
              <Jump>
                <div className="flex flex-col sm:flex-row gap-4 mt-24">
                  <Link to="/kids/all-courses">
                    <button className="bg-[#FF4B01] hover:bg-orange-600 text-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors duration-200">
                      Explore courses
                    </button>
                  </Link>
                  <a
                    href="http://tinyurl.com/cephaskids"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="bg-[#113296] hover:bg-blue-800 text-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors duration-200">
                      Enroll now
                    </button>
                  </a>
                </div>
              </Jump>
            </div>
            <div className="flex justify-center lg:justify-end">
              <Jump>
                <img
                  src={kidheroimg}
                  alt="Kids learning tech"
                  className="max-w-full h-auto rounded-lg"
                />
              </Jump>
            </div>
          </div>
        </div>
      </div>
      {/* New About Cephas Kids Section */}
      <div>
        <AboutCephasKids />
      </div>
      {/* What we offer */}
      <div>
        <WhatWeOffer />
      </div>
      {/* How it works */}
      <div>
        <HowItWorks />
      </div>
      {/* What Sets Us Apart? */}
      <div>
        <WhatSetsUsApart />
      </div>
      {/* Hear What They’re Saying About Us */}
      <div>
        <Testimonials />
      </div>
      {/* Frequently asked questions */}
      <div>
        <FAQ />
      </div>
      {/* Subscribing */}
      <div>
        <NewsletterSubscription />
      </div>
      {/* Footer */}
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default CephasKids;
